/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize DashboardStaffView View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './dashboardStaffView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsDashboardStaffViewEdit = mapStateToProps;
export const mapDispatchToPropsDashboardStaffViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsDashboardStaffViewEdit,
  mapDispatchToPropsDashboardStaffViewEdit
)(View);
